import { saveAs } from "file-saver";

export async function downloadProgressCSV(report) {
  const ExcelJS = (await import("exceljs")).default;

  const wb = new ExcelJS.Workbook();
  const ws = wb.addWorksheet("Lottery Progress");

  // === Summary block ===
  const { meta, totals } = report;

  const summary = [
    ["Сугалааны нэр", meta?.title || ""],
    ["Код", meta?.ticket_prefix || ""],
    ["Төлөв", meta?.status || ""],
    ["Харагдах байдал", meta?.visibility || ""],
    ["", ""],
    ["Нийт дугаар", totals?.total ?? 0],
    ["Зарагдсан", totals?.sold ?? 0],
    ["Зарагдаагүй", totals?.unsold ?? 0],
  ];

  ws.addRows(summary);
  ws.getRow(1).font = { bold: true };
  ws.getRow(7).font = { bold: true };

  // Хооронд нь хоосон мөр
  ws.addRow(["", ""]);
  ws.addRow(["", ""]);

  // === Data header ===
  const headerRowIdx = ws.lastRow.number + 1;
  ws.getCell(`A${headerRowIdx}`).value = "Дугаар";
  ws.getCell(`B${headerRowIdx}`).value = "Төлөв";
  ws.getCell(`C${headerRowIdx}`).value = "Зарагдсан эсэх";
  ws.getCell(`D${headerRowIdx}`).value = "Утас";
  ws.getCell(`E${headerRowIdx}`).value = "Төлбөрийн төрөл";
  ws.getCell(`F${headerRowIdx}`).value = "Авсан огноо";
  ws.getRow(headerRowIdx).font = { bold: true };

  // === Data rows ===
  const data = (report.list || []).map((r) => [
    // Код (prefix-салгасан suffix)
    r.number && r.number.includes("-") ? r.number.split("-").pop() : r.number,
    r.active ? "-" : "Идэвхгүй",
    r.is_sold ? "Тийм" : "Үгүй",
    r.phone_number ?? "",
    r.payment_method ?? "",
    r.purchased_at ? new Date(r.purchased_at).toLocaleString() : "",
  ]);

  ws.addRows(data);

  // ✅ Active=false мөрүүдийг бүдэг улаан болгох
  const startRow = headerRowIdx + 1; // data эхлэх мөр
  (report.list || []).forEach((item, idx) => {
    if (item?.active === false) {
      const rowNum = startRow + idx;
      const row = ws.getRow(rowNum);

      // Бүдэг улаан background
      row.eachCell({ includeEmpty: true }, (cell) => {
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "FFFFE0E0" }, // light red
        };

        // хүсвэл текстийг бас бүдэг болгож өгч болно
        cell.font = { color: { argb: "FF7A0000" } }; // dark red text
      });
    }
  });

  const border = { style: "thin", color: { argb: "FFBFBFBF" } };
  const setBorder = (c) =>
    (c.border = { top: border, left: border, bottom: border, right: border });

  (report.list || []).forEach((item, idx) => {
    if (item?.active === false) {
      const rowNum = startRow + idx;
      const row = ws.getRow(rowNum);

      row.eachCell({ includeEmpty: true }, (cell) => {
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "FFFFE0E0" },
        };
        cell.font = { color: { argb: "FF7A0000" } };
        setBorder(cell);
      });
    }
  });

  // Column widths
  const widths = [10, 14, 14, 16, 16, 22];
  widths.forEach((w, i) => (ws.columns[i].width = w));

  const buf = await wb.xlsx.writeBuffer();

  const prefix = meta?.ticket_prefix || "LOTTERY";
  const now = new Date();
  const timestamp = `${now.getFullYear()}${String(now.getMonth() + 1).padStart(
    2,
    "0",
  )}${String(now.getDate()).padStart(2, "0")}-${String(now.getHours()).padStart(
    2,
    "0",
  )}${String(now.getMinutes()).padStart(2, "0")}${String(
    now.getSeconds(),
  ).padStart(2, "0")}`;
  const filename = `${prefix}-${timestamp}.xlsx`;

  const blob = new Blob([buf], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });
  saveAs(blob, filename);
}
